//#region Angular Imports

import { StateService, StateProvider, StateParams } from '@uirouter/angularjs'
import * as angular from 'angular'

//#endregion

import { Api } from '../api/api.module'

import { IUserSession, UserSession, CommonHelper } from '../../helpers'
import { USER_SESSION_SERVICE_NAME, USER_SESSION_SERVICE_PROVIDER_NAME } from '../../services/user-session'
import { SYSTEM_SERVICE_NAME } from '../../services/system'

import { Activity } from '../../models/common'
import { OpOperator } from '../../models/core'

import { DashboardService, DASHBOARD_SERVICE_NAME } from '../dashboard/dashboard.service'
import { DXDashboardController, DXDashboardScope } from './dxdashboard.controller'

import {
    DXDashboardFilterComponent,
    DXDashboardSimpleComponent,
    DXDashboardMultiComponent,
    DX_DASHBOARD_FILTER_COMPONENT_NAME,
    DX_DASHBOARD_SIMPLE_COMPONENT_NAME,
    DX_DASHBOARD_MULTI_COMPONENT_NAME
} from './components'

import { DXDASHBOARD_SERVICE_NAME, DXDashboardService } from './services'

//#region Asset Imports

import './dxdashboard.scss'
import * as TEMPLATE from './dxdashboard.tpl.html'

//#endregion


// Consts

const CONTROLLER_NAME: string = 'DXDashboardController'
const MODULE_NAME: string = 'simax.dxdashboard'
const STATE_NAME: string = 'dxdashboard'
const STATE_URL: string = '/dxdashboard/{id}'

// Consts End


// Module Setup

const module = angular.module(MODULE_NAME, [])

module.component(DX_DASHBOARD_FILTER_COMPONENT_NAME, new DXDashboardFilterComponent())
module.component(DX_DASHBOARD_SIMPLE_COMPONENT_NAME, new DXDashboardSimpleComponent())
module.component(DX_DASHBOARD_MULTI_COMPONENT_NAME, new DXDashboardMultiComponent())

module.service(DXDASHBOARD_SERVICE_NAME, [SYSTEM_SERVICE_NAME, USER_SESSION_SERVICE_NAME, DXDashboardService])
module.factory(CommonHelper.Services.dashboard, [USER_SESSION_SERVICE_NAME, (userSession: IUserSession) => new DashboardService(userSession)])

module.controller(CONTROLLER_NAME, ['$scope', '$stateParams', USER_SESSION_SERVICE_NAME, 'api', '$state', '$timeout', DASHBOARD_SERVICE_NAME, '$location', (
    $scope: DXDashboardScope,
    $stateParams: StateParams,
    userSession: IUserSession,
    api: Api,
    $state: StateService,
    $timeout: ng.ITimeoutService,
    dashboardService: DashboardService,
    $location: ng.ILocationService
) => new DXDashboardController($scope, $stateParams, userSession, api, $state, $timeout, dashboardService, $location)
])

module.config(["$stateProvider", USER_SESSION_SERVICE_PROVIDER_NAME, ($stateProvider: StateProvider, userSessionProvider: UserSession) => {
    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.WEBSIMAX_DASHBOARD_VIEW)) {
                setRouting($stateProvider)
            }
        })
}])

// Module Setup End


// Route Setup

function setRouting($stateProvider: StateProvider): void {
    $stateProvider.state(STATE_NAME, {
        url: STATE_URL,
        controller: CONTROLLER_NAME,
        template: TEMPLATE,
        params: {
            id: null,
            index: null
        }
    })
}

// Route Setup End

export default MODULE_NAME